import { t } from "i18next"

const getTranslations = () => ({
  all: t("areas.armazenamento.filters.todos"),
  kitchen: t("areas.armazenamento.tipoArea.cozinha"),
  bar: t("areas.armazenamento.tipoArea.bar"),
  deposit: t("areas.armazenamento.tipoArea.deposito"),
  production: t("areas.armazenamento.tipoArea.producao"),
  closed: t("areas.armazenamento.tipoArea.trancado"),
  other: t("areas.armazenamento.tipoArea.outro"),
  active: t("areas.armazenamento.filters.ativas"),
  inactive: t("areas.armazenamento.filters.inativas"),
  central: t("areas.armazenamento.tipoArea.central"),
})

export const getTipoAreaOptions = (all) => {
  const tr = getTranslations()
  const options = [];
  if(all) {
    options.push({ value: "", label: tr.all, defaultValue: true });
  }

  options.push(
    { value: 'COZINHA', label: tr.kitchen },
    { value: 'BAR', label: tr.bar },
    { value: 'DEPOSITO', label: tr.deposit },
    { value: 'PRODUCAO', label: tr.production },
    { value: 'TRANCADO', label: tr.closed },
    { value: 'CENTRAL', label: tr.central },
    { value: 'OUTRO', label: tr.other }
  );

  return options;
}

export const getDisponibilidadeOptions = () => {
  const tr = getTranslations()
  return [
    { value: "", label: tr.all, defaultValue: true },
    { value: "S", label: tr.active },
    { value: "N", label: tr.inactive },
  ]
}
